import { render, staticRenderFns } from "./BurritoProducts.vue?vue&type=template&id=c87cf2e8&scoped=true&"
import script from "./BurritoProducts.vue?vue&type=script&lang=js&"
export * from "./BurritoProducts.vue?vue&type=script&lang=js&"
import style0 from "./BurritoProducts.vue?vue&type=style&index=0&id=c87cf2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cf2e8",
  null
  
)

export default component.exports